import ligjiPerArkivat from "../Assets/Documents/Ligji per arkivat.pdf";
import ligjiPerArkivatNdryshuar from "../Assets/Documents/Ligji 'Per arkivat' i ndryshuar.pdf";
import LigjiPerNepunesinCivil from "../Assets/Documents/Ligji per nepunesin civil.pdf";
import LigjiPPerTeDrejtenInformimit from "../Assets/Documents/Ligji per te drejten e informimit.pdf";
import LigjiPerRregullatRtikesPerAdministratenPublike from "../Assets/Documents/Ligji per rregullat e etikes per administraten publike.pdf";
import KodiEtikesNePunenArkivore from "../Assets/Documents/KODI I ETIKËS NË PUNËN ARKIVORE.pdf";
import LigjiPerInformacioninSekretShteteror from "../Assets/Documents/Ligji per informacionin Sekret Shteteror.pdf";
import LigjiPerInspektiminNeRSH from "../Assets/Documents/Ligji per Inspektimin ne RSH.pdf";
import RregullorePerLicensiminArkivavePrivate from "../Assets/Documents/Rregullore per licensimin e arkivave private.pdf";
import LigjKodiProceduraveAdministrative from "../Assets/Documents/Ligj Kodi i procedurave administrative.pdf";
import UrdherRregulloreHetiminAdministrativMbrojtjenFonfidencialitetit from "../Assets/Documents/Urdher Rregullore per Hetimin administrativ dhe mbrojtjen e konfidencialitetit.pdf";
import RregulloreDeklasifikiminZhvleresiminInformacionitSekret from "../Assets/Documents/Rregullore per deklasifikimin dhe zhvleresimin e informacionit sekret.pdf";
import UrdherRregullorePerHyrjeDaljetNeDpa from "../Assets/Documents/Urdher dhe rregullore per hyrje-daljet ne dpa.pdf";
import RregullorePerShfryteziminDokumenteveArkivoreBibliotekesFototekes from "../Assets/Documents/Rregullore per shfrytezimin e dokumenteve arkivore, bibliotekes dhe fototekes.pdf";
import RregullorePerParandaliminKonfliktitInteresave from "../Assets/Documents/Rregullore per parandalimin e konfliktit te interesave.pdf";
import Urdher316PerNdryshimeUrdhrin47 from "../Assets/Documents/Urdher nr.316 25.09.2019 per disa ndryshime ne urdhrin nr.47 31.03.2016.pdf";
import UrdherRregullorePerPraniminDokumenteveNeAqshAshv from "../Assets/Documents/Urdher dhe rregullore per pranimin e dokumenteve ne aqsh dhe ashv.pdf";
import RregulloreMbrojtjenZjarriGodinatDpa from "../Assets/Documents/Rregullore per mbrojtjen nga zjarri ne godinat e dpa.pdf";
import LigjSinjaliziminMbrojtjenSinjalizuesve from "../Assets/Documents/Ligj per sinjalizimin dhe mbrojtjen e sinjalizuesve.pdf";
import RregulloreZhvendosjenShmangienRisistemiminDokumentaveKoheVecante from "../Assets/Documents/Rregullore per zhvendosjen, shmangien dhe risistemimin e dokumentave ne kohe te vecante.pdf";
import UrdherGjurmiminRigjetjenDokumentave from "../Assets/Documents/Urdher per gjurmimin dhe rigjetjen e dokumentave.pdf";
import Vendim821 from "../Assets/Documents/VKM 821 26.12.2024.pdf";
import RregullorePlotesiminKerkesaveSocialJuridike from "../Assets/Documents/Rregullore per plotesimin e kerkesave social-juridike.pdf";
import RregulloreMasatOrganizativeUshtriminVeprimtariseDpaGjateCovid19 from "../Assets/Documents/Rregullore per masat organizative per ushtrimin e veprimtarise se dpa gjate covid 19.pdf";
import UrdherKerkesatSocialJuridikeGjatePeriudhesEmergjences from "../Assets/Documents/Urdher per kerkesat social-juridike gjate periudhes se emergjences.jpg";
import UrdherMasatOrganizativeUshtriminVeprimtariseDpaGjateCovid19 from "../Assets/Documents/Urdher per masat organizative per ushtrimin e veprimtarise se dpa gjate covid 19.pdf";
import RregulloreFunksioniminStrukturesBrendshmeDpa from "../Assets/Documents/Rregullore per funksionimin e struktures se brendshme te dpa.pdf";
import UrdherFunksioniminBrendshëmDPA from "../Assets/Documents/Urdher për Funksionimin e Brendshëm të DPA-së.pdf";
import StrategjiaAfatgjatëZhvillimitRrjetitArkivorKombëtar20202030 from "../Assets/Documents/Strategjia afatgjatë e zhvillimit të rrjetit arkivor kombëtar 2020-2030.pdf";
import RregulloreNjësuarPunësDokumentetAutoritetetPublike from "../Assets/Documents/Rregullore e njësuar e punës me dokumentet në autoritetet publike të Republikës së Shqipërisë.docx";
import ModeletDokumenteveAdministrativeWord from "../Assets/Documents/Shkarko Modelet e Dokumenteve Administrative në word.docx";
import NormatTeknikoProfesionaleRSh from "../Assets/Documents/Normat Tekniko Profesionale të Republikës së Shqipërisë.pdf";
import ListaTipAfatetuajtjesDokumenteveRëndësiHistorikeKombëtare from "../Assets/Documents/Lista Tip me Afatet e Ruajtjes së Dokumenteve me Rëndësi Historike Kombëtare.doc";
import StandardetNdërkombëtareArkivave from "../Assets/Documents/Standardet Ndërkombëtare të Arkivave.pdf";
import VKM874 from "../Assets/Documents/VKM-874.pdf";
import ManualPerEtiken from "../Assets/Documents/manual per etiken.pdf";
import UrdherRregullorePerProceduratLidhurMeBotimetShkencore from "../Assets/Documents/Urdher dhe rregullore per procedurat lidhur me botimet shkencore.PDF";
import LigjiPerAKSIK from "../Assets/Documents/Ligji-10-2023-Per-AKSIK.pdf";
import Ligj7967KodiPunesRSH from "../Assets/Documents/Ligj nr.7967 Kodi i punes i RSH.pdf";
import Ligj9887PerMbrojtjenTeDhenavePersonale from "../Assets/Documents/Ligj nr.9887 per mbrojtjen e te dhenave personale.pdf";
export const legjislacioniData = [
  {
    path: "/legjislacioni/ligje",
    title: "Legjislacioni",
    leftContent: [
      {
        title:
          "Ligji Nr.9154, datë 06.11.2003 - Për Arkivat (Ndryshuar me Ligjin nr. 27/2024, datë 4.4.2024)",
        document: ligjiPerArkivat,
      },

      {
        title:
          "Ligji Nr.152/2012 ndryshuar me Ligj Nr.178-2014 - Për nëpunësin civil",
        document: LigjiPerNepunesinCivil,
      },
      {
        title:
          "Ligji Nr.119/2014 - Për të drejtën e informimit (I ndryshuar me ligjin nr.78, datë 21.09.2023 “Për disa shtesa dhe ndryshime në ligjin nr. 119/2014 “Për të drejtën e informimit”)",
        document: LigjiPPerTeDrejtenInformimit,
      },
      {
        title: "Ligj Nr.124/2024 - Për mbrojtjen e të dhënave Personale",
        document: Ligj9887PerMbrojtjenTeDhenavePersonale,
      },
      {
        title:
          "Ligj nr.7961 datë 12.07.1995 - Kodi i punës i Republikës së Shqipërisë (Ndryshuar me ligjin nr. 8085, datë 13.3.1996; nr. 9125, datë 29.7.2003; nr. 10 053, datë 29.12.2008; nr. 136/2015, datë 5.12.2015; nr. 91/2024, datë 26.7.2024)",
        document: Ligj7967KodiPunesRSH,
      },
      {
        title:
          "Ligji nr.9131, datë - 08.09.2003 - Për rregullat e etikës në administratën publike",
        document: LigjiPerRregullatRtikesPerAdministratenPublike,
      },
      {
        title: "Kodi i etikës në punën arkivore",
        document: KodiEtikesNePunenArkivore,
      },
      {
        title: "Ligji Nr.10/2023 Për Informacionin e Klasifikuar",
        document: LigjiPerInformacioninSekretShteteror,
      },
      {
        title:
          "Ligji nr. 99/2024, datë – Për Inspektimin në Republikën e Shqipërisë",
        document: LigjiPerInspektiminNeRSH,
      },

      {
        title:
          "Ligji Nr. 44/2015 - Kodi i Procedurave Administrative i Republikës së Shqipërisë",
        document: LigjKodiProceduraveAdministrative,
      },

      {
        title:
          "Vendim nr. 35, datë 24.01.2018 Për miratimin e rregullores 'Për Licencimin e Arkivave Privatë'",
        document: RregullorePerLicensiminArkivavePrivate,
      },
      {
        title:
          "Urdhër nr.70 datë 21.01.2025 - Për miratimin e manualit praktik për etikën në administratën publike",
        document: ManualPerEtiken,
      },
      {
        title:
          "Urdhër nr.268 datë 25.05.2026 - Për miratimin e rregullores për rregullat dhe procedurat lidhur me botimet shkencore të publikuara nga Drejtoria e Përgjithshme  e Arkivave",
        document: UrdherRregullorePerProceduratLidhurMeBotimetShkencore,
      },
      {
        title:
          "Vendim nr.874 datë 29.09.2021 - Për miratimin e rregullave për zbatimin e parimeve të etikës, të klasifikimit të veprimtarive të jashtme dhe vlerën e dhuratave, që mund të pranohen gjatë veprimtarisë së nëpunësit të administrates publike",
        document: VKM874,
      },
      {
        title:
          "Vendim nr.662 datë 15.11.2017 - Për miratimin e rregullores për deklasifikimin dhe zhvlerësimin e informacionit të klasifikuar “Sekret Shtetëror”",
        document: RregulloreDeklasifikiminZhvleresiminInformacionitSekret,
      },
      {
        title:
          "Urdhër nr.389 datë 01.07.2019 - Për miratimin e rregullores së regjimit të hyrje daljeve dhe sigurimin e godinave të Drejtorisë së Përgjithshme të Arkivave",
        document: UrdherRregullorePerHyrjeDaljetNeDpa,
      },
      {
        title:
          "Urdhër nr.449 datë 05.07.2021 - Për miratimin e rregullores për shfrytëzimin e dokumenteve arkivore, bibliotekës dhe fototekës së DPA-së",
        document:
          RregullorePerShfryteziminDokumenteveArkivoreBibliotekesFototekes,
      },
      {
        title:
          "Urdhër nr.716 datë 12.12.2019 - Për miratimin e rregullores për parandalimin e konfliktit të interesave, si dhe për deklarimin e pasurive në ushtrimin e funksioneve publike në Drejtorinë e Përgjithshme të Arkivave",
        document: RregullorePerParandaliminKonfliktitInteresave,
      },
      {
        title:
          "Urdhër nr.316 datë 29.05.2019 Për disa ndryshime për urdhërin nr.47 datë 31.03.2016",
        document: Urdher316PerNdryshimeUrdhrin47,
      },
      {
        title:
          "Urdhër nr.636 datë 06.11.2019 -Për miratimin e rregullores për pranimin e dokumenteve në AQSH dhe ASHV",
        document: UrdherRregullorePerPraniminDokumenteveNeAqshAshv,
      },
      {
        title:
          "Urdhër dhe Rregullore për Hetimin Administrativ të Sinjalizimit dhe Mbrojtjen e Konfidencialitetit në DPA",
        document:
          UrdherRregulloreHetiminAdministrativMbrojtjenFonfidencialitetit,
      },
      {
        title:
          "Urdhër nr.546 datë 20.09.2019 - Për miratimin e rregullores për mbrojtjen nga zjarri dhe shpëtimin në godinat e DPA-së",
        document: RregulloreMbrojtjenZjarriGodinatDpa,
      },
      {
        title:
          "Ligj Nr. 60/2016 për sinjalizimin dhe mbrojtjen e sinjalizuesve",
        document: LigjSinjaliziminMbrojtjenSinjalizuesve,
      },
      {
        title:
          "Vendim nr.385 datë 30.06.2021 - Për miratimin e rregullores për zhvendosjen (evakuimin) shmangien dhe risistemimin e dokumenteve në kohë të veçantë",
        document:
          RregulloreZhvendosjenShmangienRisistemiminDokumentaveKoheVecante,
      },
      {
        title:
          "Urdhër nr.558 datë 10.09.2021 - Për miratimin e programit për 'Gjurmimin dhe rigjetjen e dokumentave me vlerë historike kombëtare, të humbura ose të vjedhura nga Arkivat Shtetërore'",
        document: UrdherGjurmiminRigjetjenDokumentave,
      },
    ],
    rightContent: [
      {
        title:
          "VENDIM Nr. 821, datë 26.12.2024 PËR MIRATIMIN E RREGULLORES “PËR ORGANIZIMIN DHE FUNKSIONIMIN E DREJTORISË SË PËRGJITHSHME TË ARKIVAVE DHE TË ORGANEVE QË FUNKSIONOJNË PRANË SAJ",
        doc: [
          {
            name: "VKM NR.821",
            document: Vendim821,
          },
        ],
      },
      {
        title:
          "Rregullore e kërkesave social-juridike dhe Urdhëri për Situatën e Krijuar nga Covid-19",
        doc: [
          {
            name: "Shkarko rregulloren",
            document: RregullorePlotesiminKerkesaveSocialJuridike,
          },
          {
            name: "Shkarko urdhër",
            document: UrdherKerkesatSocialJuridikeGjatePeriudhesEmergjences,
          },
        ],
      },
      {
        title:
          "Rregullore ' Për marrjen e Masave Organizative për Ushtrimin e Veprimtarisë së Drejtorisë së Përgjithshme të Arkivave gjatë Gjendjes së Epidemisë së Shkaktuar nga COVID-19 dhe Urdheri për Situatën e Krijuar nga Covid-19",
        doc: [
          {
            name: "Shkarko rregulloren",
            document:
              RregulloreMasatOrganizativeUshtriminVeprimtariseDpaGjateCovid19,
          },
          {
            name: "Shkarko urdhër",
            document:
              UrdherMasatOrganizativeUshtriminVeprimtariseDpaGjateCovid19,
          },
        ],
      },
      {
        title:
          "Urdhëri dhe Rregullorja për Funksionimin e Brendshëm të Strukturave të DPA-së",
        doc: [
          {
            name: "Urdhër nr.55 datë 10.04.2025 - Për miratimin e rregulores për metodat e brendshme të punës dhe sjelljen e personelit të Drejtorisë së Përgjithshme të Arkivave",
            document: RregulloreFunksioniminStrukturesBrendshmeDpa,
          },
        ],
      },
    ],
  },
  {
    path: "/legjislacioni/dokumente-dhe-strategji",
    title: "Dokumente dhe strategji",
    leftContent: [
      {
        name: "Strategjia afatgjatë e zhvillimit të rrjetit arkivor kombëtar 2020-2030",
        document: StrategjiaAfatgjatëZhvillimitRrjetitArkivorKombëtar20202030,
      },
      {
        name: "Rregullore e njësuar e punës me dokumentet në autoritetet publike të Republikës së Shqipërisë",
        document: RregulloreNjësuarPunësDokumentetAutoritetetPublike,
      },
      {
        name: "Shkarko Modelet e Dokumenteve Administrative në word",
        document: ModeletDokumenteveAdministrativeWord,
      },
      {
        name: "Normat Tekniko Profesionale të Republikës së Shqipërisë",
        document: NormatTeknikoProfesionaleRSh,
      },
      {
        name: "Lista Tip me Afatet e Ruajtjes së Dokumenteve me Rëndësi Historike Kombëtare",
        document: ListaTipAfatetuajtjesDokumenteveRëndësiHistorikeKombëtare,
      },
      {
        name: "Standardet Ndërkombëtare të Arkivave",
        document: StandardetNdërkombëtareArkivave,
      },
    ],
    rightContent: "",
  },
];
